import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import 'leaflet/dist/leaflet.css';
import './BcpMap.css';

const BCPEmployee = () => {
  const navigate = useNavigate();
  const [loadingGps, setLoadingGps] = React.useState(false);

  // 🌤️ 防災気象情報：GPSで現在地を取得して遷移。
  // 自宅にいれば自宅の情報のみ、外にいれば自宅＋現在地の情報を表示（サーバが自宅判定）。
  const handleWeatherClick = () => {
    if (navigator.geolocation) {
      setLoadingGps(true);

      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLoadingGps(false);
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          // 気象情報ページに緯度経度を渡して遷移
          navigate('/bcp/weather-info', { state: { lat, lng } });
        },
        (error) => {
          setLoadingGps(false);
          console.warn("K:", error.message);
          // GPSの取得に失敗した場合は、緯度経度なしで遷移
          navigate('/bcp/weather-info', { state: { lat: null, lng: null } });
        },
        { timeout: 5000 } // 5秒でタイムアウトするように設定
      );
    } else {
      // GPSがサポートされていない場合は、緯度経度なしで遷移
      navigate('/bcp/weather-info', { state: { lat: null, lng: null } });
    }
  };

  return (
    <div className="bcp-page bcp-menu-page">
      <header className="bcp-menu-header">
        <h1 className="bcp-menu-title">BCP 避難所検索</h1>
        <p className="bcp-menu-desc">登録住所または現在地から、最寄りの避難所を検索します。</p>
      </header>
      <div className="bcp-menu-actions">
        <div className="bcp-btn-group">
          <Link className="bcp-btn-home" to="/bcp/home-shelter">
            🏠 登録住所から探す
          </Link>

          <Link className="bcp-btn-nearby" to="/bcp/nearby-shelter">
            📍 現在地から探す
          </Link>

          <Link className="bcp-btn-nearby" to="/bcp/search-address" style={{ backgroundColor: "#e0f2fe", color: "#0369a1", border: "1px solid #bae6fd" }}>
            🔍 任意の住所から探す
          </Link>

          <button type="button" className="bcp-btn-weather" onClick={handleWeatherClick} disabled={loadingGps}>
             {loadingGps ? '⌛ 位置情報を取得中...' : '🌤️ 防災気象情報'}
          </button>
          
          <button type="button" className="bcp-btn-menu-back" onClick={() => navigate('/card_back')}>
            戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default BCPEmployee;
